//课中活动讨论
export const MUTUALEVALUATE_LIST = 'mutualevaluate_list'
export const MUTUALEVALUATE_INFO = 'mutualevaluate_info'
//过程性评价
export const SCORESTURECORD_LIST = 'scoreStuRecord_list'
export const SCORESTURECORD_INFO = 'scoreStuRecord_info'


// WEBPACK FOOTER //
// ./src/store/kzActivity/mutualEvaluate/type.js